import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

function LinkedInCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleCallback = () => {
      const urlParams = new URLSearchParams(location.search);
      const data = urlParams.get('data');
      const error = urlParams.get('error');

      if (error) {
        setError(decodeURIComponent(error));
        setLoading(false);
        setTimeout(() => {
          navigate('/register');
        }, 3000);
        return;
      }

      if (data) {
        try {
          const userData = JSON.parse(decodeURIComponent(data));
          
          // Store user data in localStorage
          localStorage.setItem('userInfo', JSON.stringify(userData));
          
          // Show success message
          setLoading(false);
          
          // Redirect to dashboard after a short delay
          setTimeout(() => {
            navigate('/dashboard');
          }, 1500);
        } catch (parseError) {
          console.error('Error parsing user data:', parseError);
          setError('Failed to process authentication data');
          setLoading(false);
          setTimeout(() => {
            navigate('/register');
          }, 3000);
        }
      } else {
        setError('No authentication data received');
        setLoading(false);
        setTimeout(() => {
          navigate('/register');
        }, 3000);
      }
    };

    handleCallback();
  }, [location, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 3
      }}
    >
      {loading ? (
        <>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
            Completing LinkedIn Authentication...
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            Please wait while we set up your account.
          </Typography>
        </>
      ) : error ? (
        <>
          <Alert severity="error" sx={{ mb: 3, maxWidth: 400 }}>
            {error}
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            Redirecting to registration page...
          </Typography>
        </>
      ) : (
        <>
          <Alert severity="success" sx={{ mb: 3, maxWidth: 400 }}>
            LinkedIn authentication successful! Welcome to Getlista.
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            Redirecting to dashboard...
          </Typography>
        </>
      )}
    </Box>
  );
}

export default LinkedInCallback; 